<template>
  <div class="result-list-container cs-scroll-style">
    <SpinnerContainer v-if="!uiResults && this.$store.state.appConfig.isLoading"/>
    <template v-else>
      <div class="pop-view" v-if="uiResults">
        <div v-for="itemAncestry in uiResults.resultList"
            :key="itemAncestry.resultName" 
            @click="onOpenDetailPage(itemAncestry)" class="pop-view-item" 
            :class="{'selected' : $store.state.hgFarmerResult.openedHgFarmerDetail.id === itemAncestry.id && $store.state.appConfig.windowWidth >= 769}"
            v-click-track="'Iframe.ancientDnaHGAndFarmerPopulationClickFromLeftPanel'">
          <div class="d-flex">
            <b-media-aside class="mr-75">
              <b-avatar
                rounded
                size="55"
                :src="itemAncestry.logoUrl"
              />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                {{ itemAncestry.title }}
              </h6>
            </b-media-body>
          </div>
          <div class="d-flex align-items-center lab-p-8">
            <span class="mr-75 percent-txt"><b>{{ itemAncestry.resultValue.toFixed(1) }}%</b></span>
            <vue-apex-charts
              type="radialBar"
              height="40"
              width="40"
              :options="onGetChartOption(itemAncestry.color)"
              :series="[itemAncestry.resultValue.toFixed(1)]"
            />
          </div>
        </div>
      </div>
    </template>    
  </div>
</template>

<script>
import { DistanceColor } from '@/services/Base/utils'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
  },
  directives: {
  },
  data() {
    return {
    }
  },
  methods: {
    /* eslint-disable */
    onGetChartOption(color) {
      const barColor = color ? color : '#00ADB5';
      return {
        grid: {
          show: false,
          padding: {
            left: -15,
            right: -15,
            top: -12,
            bottom: -15,
          },
        },
        colors: [barColor],
        plotOptions: {
          radialBar: {
            hollow: {
              size: '22%',
            },
            track: {
              background: this.ddAlpha(color, 0.1),
            },
            dataLabels: {
              showOn: 'always',
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
      };
    },
    ddAlpha(color, opacity) {
      let _opacity = Math.round(Math.min(Math.max(opacity ?? 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    },
    fitTitle(value) {
      if(value > 0 && value <= 3) {
        return 'Very close';
      }
      if(value > 3 && value <= 5) {
        return 'Close';
      }
      if(value > 5 && value <= 6) {
        return 'Moderate';
      }
      return 'Distant';
    },
    DistanceColor,

    onOpenDetailPage(item) {
      if (!item.id) {
        return;
      }
      this.$store.dispatch('hgFarmerResult/fetchHgFarmerDetail', item.id);
      this.$store.state.hgFarmerResult.isOpenedHgFarmerDetail = true;
    },
  },
  computed: {
    uiResults() {
      return this.$store.getters['hgFarmerResult/getUiResults'];
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.result-list-container {
  padding: 28px;
  flex: 1;
  overflow-y: auto;

  .pop-view-item.selected {
    box-shadow: 0px 0px 10px 0px #A73CBD33;
    border: 1px solid #D988ED;
  }

  @media screen and (max-width: 769px) {
    overflow-y: hidden;
    overflow-x: hidden !important;
  }
}
</style>
